(ns rothko.styles.vars.basic
  (:require [garden.color :as color :refer [rgb rgba]]
            [garden.units :as units]
            [rothko.styles.vars.common :as common]))

;; Vars
(def colours
  (merge common/colours {:blue-border-dark (rgb 54 61 85)
                         :blue-darkest (rgb 20 25 48)
                         :blue-dark (rgb 32 39 67)
                         :blue-light (rgb 32 138 231)
                         :orange (rgb 242 123 54)
                         :green (rgb 34 188 155)
                         :green-dark (rgb 24 158 85)
                         :audio-level-green (rgb 112 249 63)
                         :audio-level-red (rgb 247 28 28)
                         :audio-level-yellow (rgb 243 235 45)
                         :grey-bg-gradient-dark (rgba 198 200 207 0.4)
                         :grey-bg-gradient-light (rgb 241 241 243)
                         :red (rgb 234 107 107)
                         :red-dark (rgb 169 68 66)
                         :red-light (rgba 169 68 66 0.2)}))

;; Extend common Fonts variable
(def fonts
  common/fonts)

;; Extend common Fonts variable
(def font-sizes
  common/font-sizes)

;; Extend common Font-weights variable
(def font-weights
  common/font-weights)

;; Extend common Line-heights variable
(def line-heights
  common/line-heights)

;; Extend common Media variable
(def media
  common/media)

;; Text
(def ^:private text-colour (color/lighten (:black colours) 15))

(def text
  {:text-colour text-colour})

;; Gradients
(def gradients
  {:grey-bg ["repeating-linear-gradient(135deg"
             [(:grey-bg-gradient-dark colours)] [(:grey-bg-gradient-dark colours) (units/px 1)]
             [(:grey-bg-gradient-light colours) (units/px 2)] [(:grey-bg-gradient-light colours) (units/px 10) ")"]]})

;; Shadows
(def shadows
  {:deep-shadow [[0 (units/px 2) (units/px 10) 0 (rgba 0 0 0 0.1)]]
   :footer-shadow [[0 (units/px -2) (units/px 10) 0 (merge (:black colours) {:alpha 0.25})]]
   :header-shadow [[0 (units/px 2) (units/px 10) 0 (merge (:black colours) {:alpha 0.25})]]})

;; Duration values
(def duration-values
  {:fast 200
   :normal 300
   :slow 400})

;; Durations
(def durations
  {:fast (units/ms (:fast duration-values))
   :normal (units/ms (:normal duration-values))
   :slow (units/ms (:slow duration-values))})

;; Extend common Arrows variable
(defn arrow-mixin
  [args]
  (common/arrow-mixin args))
